window.Intl = window.Intl || {};
Intl.DateTimeFormat =
  Intl.DateTimeFormat ||
  class {
    format = (date) => {
      return `${date.getDate()}-${date.getMonth() + 1}-${date.getFullYear()}`;
    };
  };
